module.exports = __webpack_public_path__ + "img/q15.725855b8.png";